import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface RankChangesState {
  rank_change_aggregation_type: string;
  rank_change_time_frame: number;
  addRow: boolean;
  view: number;
  isChart: boolean;
  seller: string;
  seller_name: string;
  asins: { id: number; asin: string }[];
}

export const initialState: RankChangesState = {
  rank_change_aggregation_type: "week",
  rank_change_time_frame: 6,
  addRow: false,
  view: 1,
  isChart: false,
  asins: [],
  seller: "",
  seller_name: "",
};

export const rankChangesSlice = createSlice({
  name: "rankChanges",
  initialState,
  reducers: {
    changeRankChangesAggregation: (
      state: RankChangesState,
      action: PayloadAction<string>
    ) => {
      state.rank_change_aggregation_type = action.payload;
    },
    changeRankChangesTimeFrame: (
      state: RankChangesState,
      action: PayloadAction<string>
    ) => {
      state.rank_change_time_frame = Number(action.payload);
    },
    changeRankChangesView: (
      state: RankChangesState,
      action: PayloadAction<number>
    ) => {
      state.view = action.payload;
    },
    changeAddRow: (state: RankChangesState, action: PayloadAction<boolean>) => {
      state.addRow = action.payload;
    },
    addRankAsins: (
      state: RankChangesState,
      action: PayloadAction<{ id: number; asin: string }[]>
    ) => {
      state.asins = action.payload;
    },
    removeRankAsins: (state: RankChangesState) => {
      state.asins = [];
    },

    addRankChangesSeller: (
      state: RankChangesState,
      action: PayloadAction<string>
    ) => {
      state.seller = action.payload;
    },
    addRankChangesSellerName: (
      state: RankChangesState,
      action: PayloadAction<string>
    ) => {
      state.seller_name = action.payload;
    },
    toggleChartViewRankChanges: (
      state: RankChangesState,
      action: PayloadAction<boolean>
    ) => {
      state.isChart = action.payload;
    },
  },
});

export const {
  changeRankChangesAggregation,
  changeRankChangesTimeFrame,
  changeAddRow,
  changeRankChangesView,
  addRankAsins,
  removeRankAsins,
  addRankChangesSeller,
  addRankChangesSellerName,
  toggleChartViewRankChanges,
} = rankChangesSlice.actions;
